import { render, staticRenderFns } from "./ClinicPersonnelManage.vue?vue&type=template&id=8d9d2232&scoped=true"
import script from "./ClinicPersonnelManage.vue?vue&type=script&lang=js"
export * from "./ClinicPersonnelManage.vue?vue&type=script&lang=js"
import style0 from "./ClinicPersonnelManage.vue?vue&type=style&index=0&id=8d9d2232&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d9d2232",
  null
  
)

export default component.exports